import { render, staticRenderFns } from "./omt-h2.vue?vue&type=template&id=5c947992&scoped=true&"
var script = {}
import style0 from "./omt-h2.vue?vue&type=style&index=0&id=5c947992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c947992",
  null
  
)

export default component.exports